import { Message } from '#/entities/message'

import { ChatSearchHit } from './types'

export function normalizeSlug(value: string | null | undefined) {
	if (!value) {
		return null
	}
	const slug = value.trim().toLowerCase()
	if (!slug || /\s/.test(slug)) {
		return null
	}
	return slug
}

export function slugFromModel(model: Message['model'] | ChatSearchHit['model']) {
	if (!model) {
		return null
	}
	if (typeof model === 'string') {
		return normalizeSlug(model)
	}
	return normalizeSlug(model.slug)
}

export function slugFromSearchHit(hit: ChatSearchHit) {
	return normalizeSlug(hit.model_slug) || slugFromModel(hit.model)
}
